'use client';

import { NumberInput, type NumberInputProps } from '@mantine/core';
import type { Ref } from 'react';
import styles from './NumberField.module.css';

type NumberFieldProps = Omit<NumberInputProps, 'leftSection' | 'rightSection'> & {
  ref?: Ref<HTMLInputElement>;
};

const sectionWidth = (text: string) => Math.max(32, text.trim().length * 8 + 20);

/** Units stay outside the editable value, in Mantine's non-interactive input sections. */
export function NumberField({ prefix, suffix, ref, className, ...props }: NumberFieldProps) {
  return (
    <NumberInput
      {...props}
      className={[styles.field, className].filter(Boolean).join(' ')}
      ref={ref}
      hideControls
      leftSection={prefix ? <span className={styles.prefix}>{prefix.trim()}</span> : undefined}
      leftSectionWidth={prefix ? sectionWidth(prefix) : undefined}
      leftSectionPointerEvents="none"
      rightSection={suffix ? <span className={styles.suffix}>{suffix.trim()}</span> : undefined}
      rightSectionWidth={suffix ? sectionWidth(suffix) : undefined}
      rightSectionPointerEvents="none"
    />
  );
}
